/**
 * Parameter Display Component
 * Shows current parameter being edited with auto-hide
 * Uses ParameterDisplay from ui-components for layout
 */

import {
  ParameterDisplay as ParameterDisplayUI,
  type PitchNote,
} from '@midi-volca-drum/ui-components';
import { useMIDIStore, calculatePitchNoteOpacity } from '@midi-volca-drum/midi';
import { useSettings } from '@contexts/SettingsContext';

export const ParameterDisplay = () => {
  const parameterDisplay = useMIDIStore(state => state.parameterDisplay);
  const { debugMode } = useSettings();

  // Don't render if debug mode is disabled
  if (!debugMode) {
    return null;
  }

  // Build pitch notes with opacity values
  let pitchNotes: PitchNote[] | undefined;
  if (parameterDisplay.pitchNotes) {
    const activeIndex = parameterDisplay.pitchNotes.findIndex(n => n.isActive);
    pitchNotes = parameterDisplay.pitchNotes.map((n, index) => {
      const distance = Math.abs(index - activeIndex);
      return {
        note: n.note,
        isActive: n.isActive,
        opacity: n.isActive ? 1 : calculatePitchNoteOpacity(distance),
      };
    });
  }

  return (
    <ParameterDisplayUI
      show={parameterDisplay.show}
      name={parameterDisplay.name}
      transformedValue={parameterDisplay.transformedValue}
      rawValue={parameterDisplay.rawValue}
      ccNumber={parameterDisplay.ccNumber}
      pitchNotes={pitchNotes}
    />
  );
};
